import triggerClick from '../utils/triggerClick';

// setting
const setTab = function($target, callback) { // eslint-disable-line
  const _this = this; // eslint-disable-line

  if (!$target) return;

  const $controller = [].slice.call($target.querySelectorAll('[role="tablist"] [role="tab"]'));
  if (!$controller[0]) return;
  _this.controller = $controller;

  const $tabpanel = [].slice.call($target.querySelectorAll('[role="tabpanel"]'));
  if (!$tabpanel[0]) return;
  _this.tabpanel = $tabpanel;

  _this.list = [];

  _this.callback = callback || function() {}; // eslint-disable-line
};

// init
setTab.prototype.init = function() { // eslint-disable-line
  const _this = this; // eslint-disable-line

  Array.prototype.forEach.call(_this.controller, (o, i) => {
    const targetName = o.getAttribute('aria-controls');
    _this.list.push({
      index: i,
      id: targetName,
      tab: o,
      tabpanel: document.getElementById(o.getAttribute('aria-controls')),
      selected: !(i > 0),
    });
    o.addEventListener('click', _this.setCurrent.bind(_this), false);
    o.addEventListener('keydown', _this.actKey, false);
  });
};

// set current
setTab.prototype.setCurrent = function(e) { // eslint-disable-line
  const _this = this; // eslint-disable-line
  const targetName = e.currentTarget.getAttribute('aria-controls');

  Array.prototype.forEach.call(_this.list, item => {
    item.selected = targetName === item.id; // eslint-disable-line
    item.tab.setAttribute('aria-selected', item.selected ? 'true' : 'false');
    item.tabpanel.setAttribute('aria-hidden', item.selected ? 'false' : 'true');
  });

  _this.callback.call(_this, targetName);
};

// key control
setTab.prototype.actKey = function(e) { // eslint-disable-line
  if (e.keyCode === 32) {
    triggerClick(e.currentTarget);
    const targetName = e.currentTarget.getAttribute('aria-controls');
    const focusTarget = document
      .getElementById(targetName)
      .querySelector('a,input,area,button,select,[tabindex],textarea');
    if (focusTarget) focusTarget.focus();
    e.stopPropagation();
    e.preventDefault();
  }
};

// shift current
setTab.prototype.changeCurrent = function(direction) { // eslint-disable-line
  const _this = this; // eslint-disable-line
  const max = _this.list.length - 1;
  const current = _this.list.filter(o => o.selected).pop();
  let targetIndex = current.index + direction;
  targetIndex = targetIndex < 0 ? max : targetIndex > max ? 0 : targetIndex; // eslint-disable-line
  triggerClick(_this.list[targetIndex].tab);
  // tab key 操作
  if (event.clientX <= 0 && event.clientY <= 0) { // eslint-disable-line
    const focusTarget = _this.list[targetIndex].tabpanel.querySelector(
      'a,input,area,button,select,[tabindex],textarea',
    );
    if (focusTarget) focusTarget.focus();
  }
};

// EXPORT
export default ($target, callback) => new setTab($target, callback); // eslint-disable-line
